import { FormEvent, startTransition, useRef } from 'react';
import { useFormStatus } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';

import type { ChangePasswordFields } from './ChangePasswordPage';
import { FrontPage } from './FrontPage';
import { PasswordField } from '@/components/common/PasswordField';
import { State } from '@/types';

import './ResetPassword.css';

function Submit() {
  const { pending } = useFormStatus();
  const { t } = useTranslation();

  return (
    <Button
      sx={{ marginBottom: '10%' }}
      className="reset-password-page-submit-button"
      type="submit"
      fullWidth
      variant="contained"
      disabled={pending}
    >
      {t('login.resetPassword.passwordChangeButton')}
    </Button>
  );
}

function ChangePassword({
  state,
  formAction,
  isPhone,
}: {
  state: State<ChangePasswordFields>;
  formAction: (payload: ChangePasswordFields) => void;
  isPhone: boolean;
}) {
  const { t } = useTranslation();
  const ref = useRef<HTMLFormElement | null>(null);

  function handleSubmit(event: FormEvent<HTMLFormElement> | undefined) {
    event?.preventDefault();
    const formData = new FormData(ref.current!);
    const formPayload = Object.fromEntries(formData) as ChangePasswordFields;

    startTransition(() => formAction(formPayload));
  }

  return (
    <>
      {!isPhone && (
        <div className="login-page-right-title">
          <h1 className="reset-password-page-title-forgot">{t('login.resetPassword.passwordChange')}</h1>
        </div>
      )}

      <Box component="form" ref={ref} onSubmit={handleSubmit} noValidate>
        <PasswordField name="password" labelKey="login.password" error={state.errors.password} autoFocus={true} />
        <PasswordField
          name="passwordAgain"
          labelKey="login.resetPassword.passwordAgain"
          error={state.errors.passwordAgain}
          autoComplete="new-password"
        />

        <Submit />
      </Box>
    </>
  );
}

export function ChangePasswordForm({
  state,
  formAction,
  isPhone,
}: {
  state: State<ChangePasswordFields>;
  formAction: (payload: ChangePasswordFields) => void;
  isPhone: boolean;
}) {
  return (
    <FrontPage isPhone={isPhone}>
      <ChangePassword state={state} formAction={formAction} isPhone={isPhone} />
    </FrontPage>
  );
}
